module.exports = __webpack_public_path__ + "img/aoc.a3ad21dd.svg";